import Result from "@/core/common/Result";

export interface IDesativarVoucherGateway {
  desativarVoucher(voucherId: string): Promise<Result<void>>;
}

export const desativarVoucherGatewayDI = "desativarVoucherGatewayDI";
